module.exports = __webpack_public_path__ + "static/img/arrow.580664a6.png";